import { CALL_API } from "admin/middlewares/api";

export const MPL_FINANCING_LIST_CHANGE_PAGE = "MPL_FINANCING_LIST_CHANGE_PAGE";

export function change_financing_list_page(page, financingType) {
  return {
    type: MPL_FINANCING_LIST_CHANGE_PAGE,
    financingType,
    page,
  };
}

export const MPL_FINANCING_LIST_CHANGE_FILTER =
  "MPL_FINANCING_LIST_CHANGE_FILTER";

export function change_financing_list_filter(key, value, financingType) {
  let filter = {};
  filter[key] = value;

  return {
    type: MPL_FINANCING_LIST_CHANGE_FILTER,
    financingType,
    filter,
  };
}

export const MPL_FINANCING_CLOSE_REQUEST = "MPL_FINANCING_CLOSE_REQUEST";
export const MPL_FINANCING_CLOSE_SUCCESS = "MPL_FINANCING_CLOSE_SUCCESS";
export const MPL_FINANCING_CLOSE_ERROR = "MPL_FINANCING_CLOSE_ERROR";

export function close_financing(financingId, shouldUnpublish) {
  let success = shouldUnpublish
    ? { method: close_and_unpublish.bind(this, financingId) }
    : MPL_FINANCING_CLOSE_SUCCESS;

  return {
    [CALL_API]: {
      endpoint: "/api/admin/financings/close",
      method: "POST",
      data: { FinancingId: financingId },
      authenticatedRequest: true,
      types: [MPL_FINANCING_CLOSE_REQUEST, success, MPL_FINANCING_CLOSE_ERROR],
    },
  };
}

export const MPL_FINANCING_OPEN_REQUEST = "MPL_FINANCING_OPEN_REQUEST";
export const MPL_FINANCING_OPEN_SUCCESS = "MPL_FINANCING_OPEN_SUCCESS";
export const MPL_FINANCING_OPEN_ERROR = "MPL_FINANCING_OPEN_ERROR";

export function open_financing(financingId, shouldPublish) {
  let success = shouldPublish
    ? { method: open_and_publish.bind(this, financingId, open) }
    : MPL_FINANCING_OPEN_SUCCESS;

  return {
    [CALL_API]: {
      endpoint: "/api/admin/financings/open",
      method: "POST",
      data: { FinancingId: financingId },
      authenticatedRequest: true,
      types: [MPL_FINANCING_OPEN_REQUEST, success, MPL_FINANCING_OPEN_ERROR],
    },
  };
}

export const MPL_FINANCING_REGISTER_PAYOUT_REQUEST =
  "MPL_FINANCING_REGISTER_PAYOUT_REQUEST";
export const MPL_FINANCING_REGISTER_PAYOUT_SUCCESS =
  "MPL_FINANCING_REGISTER_PAYOUT_SUCCESS";
export const MPL_FINANCING_REGISTER_PAYOUT_ERROR =
  "MPL_FINANCING_REGISTER_PAYOUT_ERROR";

export function register_financing_payout(financingId, bankingDate) {
  return {
    [CALL_API]: {
      endpoint: "/api/admin/financings/mpl/confirm-payout",
      method: "POST",
      data: { FinancingId: financingId, BankingDate: bankingDate },
      authenticatedRequest: true,
      types: [
        MPL_FINANCING_REGISTER_PAYOUT_REQUEST,
        MPL_FINANCING_REGISTER_PAYOUT_SUCCESS,
        MPL_FINANCING_REGISTER_PAYOUT_ERROR,
      ],
    },
  };
}

export const MPL_FINANCING_PUBLISH_REQUEST = "MPL_FINANCING_PUBLISH_REQUEST";
export const MPL_FINANCING_PUBLISH_SUCCESS = "MPL_FINANCING_PUBLISH_SUCCESS";
export const MPL_FINANCING_PUBLISH_ERROR = "MPL_FINANCING_PUBLISH_ERROR";

function open_and_publish(financingId) {
  return (dispatch) => {
    dispatch({
      type: MPL_FINANCING_OPEN_SUCCESS,
      financingId,
    });
    dispatch(publish_financing(financingId));
  };
}

export function publish_financing(financingId) {
  return {
    [CALL_API]: {
      endpoint: "/api/admin/financings/publish",
      method: "POST",
      data: { FinancingId: financingId },
      authenticatedRequest: true,
      types: [
        MPL_FINANCING_PUBLISH_REQUEST,
        MPL_FINANCING_PUBLISH_SUCCESS,
        MPL_FINANCING_PUBLISH_ERROR,
      ],
    },
  };
}

export const MPL_FINANCING_UNPUBLISH_REQUEST =
  "MPL_FINANCING_UNPUBLISH_REQUEST";
export const MPL_FINANCING_UNPUBLISH_SUCCESS =
  "MPL_FINANCING_UNPUBLISH_SUCCESS";
export const MPL_FINANCING_UNPUBLISH_ERROR = "MPL_FINANCING_UNPUBLISH_ERROR";

function close_and_unpublish(financingId) {
  return (dispatch) => {
    dispatch({
      type: MPL_FINANCING_CLOSE_SUCCESS,
      financingId,
    });
    dispatch(unpublish_financing(financingId));
  };
}

export function unpublish_financing(financingId) {
  return {
    [CALL_API]: {
      endpoint: "/api/admin/financings/unpublish",
      method: "POST",
      data: { FinancingId: financingId },
      authenticatedRequest: true,
      types: [
        MPL_FINANCING_UNPUBLISH_REQUEST,
        MPL_FINANCING_UNPUBLISH_SUCCESS,
        MPL_FINANCING_UNPUBLISH_ERROR,
      ],
    },
  };
}

export const MPL_CANCEL_FINANCING_REQUEST = "MPL_CANCEL_FINANCING_REQUEST";
export const MPL_CANCEL_FINANCING_SUCCESS = "MPL_CANCEL_FINANCING_SUCCESS";
export const MPL_CANCEL_FINANCING_ERROR = "MPL_CANCEL_FINANCING_ERROR";

export function cancel_financing(financingId) {
  return {
    [CALL_API]: {
      endpoint: "/api/admin/financings/cancel",
      method: "POST",
      data: { FinancingId: financingId },
      authenticatedRequest: true,
      types: [
        MPL_CANCEL_FINANCING_REQUEST,
        MPL_CANCEL_FINANCING_SUCCESS,
        MPL_CANCEL_FINANCING_ERROR,
      ],
    },
  };
}

export const MPL_FINANCING_PAYOUT_INFO_REQUEST =
  "MPL_FINANCING_PAYOUT_INFO_REQUEST";
export const MPL_FINANCING_PAYOUT_INFO_SUCCESS =
  "MPL_FINANCING_PAYOUT_INFO_SUCCESS";
export const MPL_FINANCING_PAYOUT_INFO_ERROR =
  "MPL_FINANCING_PAYOUT_INFO_ERROR";

export function get_financing_payout_info(financingId, offerId) {
  let url = `/api/admin/financings/mpl/payout-info?financingId=${financingId}`;
  return {
    [CALL_API]: {
      endpoint: url,
      method: "GET",
      data: { FinancingId: financingId, OfferId: offerId },
      authenticatedRequest: true,
      types: [
        MPL_FINANCING_PAYOUT_INFO_REQUEST,
        MPL_FINANCING_PAYOUT_INFO_SUCCESS,
        MPL_FINANCING_PAYOUT_INFO_ERROR,
      ],
    },
  };
}

export const MPL_FINANCING_REALISE_REQUEST = "MPL_FINANCING_REALISE_REQUEST";
export const MPL_FINANCING_REALISE_SUCCESS = "MPL_FINANCING_REALISE_SUCCESS";
export const MPL_FINANCING_REALISE_ERROR = "MPL_FINANCING_REALISE_ERROR";

export function realise_financing(financingId) {
  return {
    [CALL_API]: {
      endpoint: "/api/admin/financings/realise",
      method: "POST",
      data: { FinancingId: financingId },
      authenticatedRequest: true,
      types: [
        MPL_FINANCING_REALISE_REQUEST,
        MPL_FINANCING_REALISE_SUCCESS,
        MPL_FINANCING_REALISE_ERROR,
      ],
    },
  };
}
